const getSelectedIndexAfterMove = (
  sourceIndex: number,
  destinationIndex: number,
  selectedVideoIndex: number
): number | null => {
  if (sourceIndex === selectedVideoIndex) {
    // if dragging the selected video, the selected index should match where it's being dragged to
    return destinationIndex;
  }
  if (sourceIndex < selectedVideoIndex && destinationIndex >= selectedVideoIndex) {
    // if the item being moved is above the selected video and being dragged below the selected, then the new selected video position needs to be moved up 1
    return selectedVideoIndex - 1;
  }
  if (sourceIndex > selectedVideoIndex && destinationIndex <= selectedVideoIndex) {
    // if the item being moved is below the selected video and being dragged above the selected, then the new selected video position needs to be moved down 1
    return selectedVideoIndex + 1;
  }
  // in all other instances, selectedVideoIdx should not change
  return null;
};

export default getSelectedIndexAfterMove;
